import {View} from "react-native";
import {ThemedText, ThemedView} from "@app/theme";
import React from "react";
import {addCommasToNumber} from "@app/utils";

interface ProcessingFeeItem {
    index: number;
    chargeType: string;
    amount: number;
}

interface ProcessingChargesProps {
    processingFeeObject: ProcessingFeeItem[];
}

const ProcessingChargesBreakUp: React.FC<ProcessingChargesProps> = ({ processingFeeObject }) => {
    return (
        <View>
            {processingFeeObject.map((item) => (
                <ThemedView 
                    key={item.index}
                    flexDirection={"row"} 
                    justifyContent={"space-between"} 
                    alignItems={"center"}
                    mb={"xs"}
                >
                    <ThemedText variant={"b4r"} color={"text-primary"}>
                        {`• ${item.chargeType}`}
                    </ThemedText>
                    <ThemedText variant={"b4s"} color={"text-primary"} mt={"sm"}>
                        {`₹${addCommasToNumber(item.amount)}`}
                    </ThemedText>
                </ThemedView>
            ))}
        </View>
    );
};

export default ProcessingChargesBreakUp;
